import React from 'react';
import './SavingLoader.css';
import { useLoaderStore } from './SavingStore';

export const useSavingLoader = () => useLoaderStore;

export const SavingLoaderProvider = ({ children }) => {
  const { isLoading, message, progress } = useLoaderStore();

  return (
    <>
      {children}
      {isLoading && (
        <div className="saving-loader-overlay">
          <div className="saving-loader-content">
            <div className="saving-loader-spinner"></div>
            <p className="saving-loader-message">{message}</p>
            {progress > 0 && (
              <div className="saving-loader-progress">
                <div className="saving-loader-progress-bar" style={{ width: `${progress}%` }}></div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};
